<div class="d-flex flex-column h-100">

  <!-- Header -->
  <div class="panel-section-header px-3 pt-2 pb-2 flex-shrink-0">
    <div class="panel-eyebrow mat-font-label-sm text-uppercase fw-semibold mb-1">
      Custom Elements · Results
    </div>
    <div class="d-flex align-items-center gap-1 mb-1">
      <h2 class="mat-font-title-md fw-semibold mb-0">Detection results</h2>
    </div>
    <p class="mat-font-body-sm mb-0">
      {{ detection.totalDetections() | number }} objects across
      {{ detection.objects().length }} type{{ detection.objects().length !== 1 ? 's' : '' }}.
    </p>
  </div>

  <!-- Body -->
  <div class="overflow-y-auto overflow-x-hidden flex-fill px-3 py-3 d-flex flex-column gap-3">
    <!-- Detections by type -->
    <div>
      <div class="d-flex align-items-center justify-content-between mb-2">
        <span class="mat-font-label-sm text-uppercase fw-semibold">
          Detections by type
        </span>
      </div>

      <div class="d-flex flex-column gap-1">
        @for (obj of detection.objects(); track obj.name) {
          <lib-detection-group
            [object]="obj"
            [result]="getResult(obj.name)"
            [visible]="isVisible(obj.name)"/>
        }
      </div>
    </div>

    <!-- Area read-only -->
<!--    <div>-->
<!--      <div class="mat-font-label-sm mb-2"-->
<!--           style="color: var(&#45;&#45;mat-sys-on-surface-variant); letter-spacing: 0.04em; text-transform: uppercase; font-weight: 600;">-->
<!--        Area-->
<!--      </div>-->
<!--      <lib-area-summary-card [area]="detection.area()" [showChangeButton]="false" />-->
<!--    </div>-->


  </div>

  <!-- Footer -->
  <div class="px-3 py-2 flex-shrink-0 d-flex gap-2">
      <button matButton type="button" class="flex-fill" (click)="backToConfig()">
        Back to config
      </button>
    <button matButton="filled" color="primary" class="flex-fill" type="button" (click)="openExportAll()">
      Export
    </button>
  </div>

</div>
